import LineChart from './LineChart';
import UIBuilder from '../BaseComponent';
import { UI_COMPONENTS_TYPE_FIELD } from '../../../../Constant/Constant';

export default class LineChartBuilder extends UIBuilder {
  constructor() {
    super();
    this.schema = {
      data: UI_COMPONENTS_TYPE_FIELD.JSON,
    };
  }

  getType = () => {
    return 'line_chart';
  };

  getComponent = () => {
    return LineChart;
  };
}
